export default __webpack_public_path__ + "static/media/soundfalse.cbdaeb94.mp3";